import SectionWrapper from "../../components/SectionWrapper";
import { useAppSelector } from "../../redux/hooks";

const CompanySection = () => {
    const { user } = useAppSelector(state => state.auth);
    return (
        <SectionWrapper className="d-flex justify-content-center align-items-center">
            <p className="font-24 text-theme text-center m-0 fw-bold">{user?.company || "Company Name"}</p>
        </SectionWrapper>
    );
};

export default CompanySection;
